/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent } from "react";
import { viewMode } from "../../../utils/utils";
import "./scss/ResultMode.scss";

interface ResultModeProps {
  resultMode: string;
  changeView: Function;
}

export const ResultMode: FunctionComponent<ResultModeProps> = (props) => {
  const { resultMode, changeView } = props;

  const renderGridMode = () => {
    return (
      <div className="modes">
        <strong className="modes-label" id="modes-label">
          View as
        </strong>
        <strong
          title="Grid"
          className="modes-mode active mode-grid"
          data-value="grid"
        >
          <span>Grid</span>
        </strong>
        <a
          className="modes-mode mode-list"
          title="List"
          data-role="mode-switcher"
          data-value="list"
          id="mode-list"
          aria-labelledby="modes-label mode-list"
          onClick={() => changeView(viewMode.LIST)}
        >
          <span>List</span>
        </a>
      </div>
    );
  };

  const renderListMode = () => {
    return (
      <div className="modes">
        <strong className="modes-label" id="modes-label">
          View as
        </strong>
        <a
          className="modes-mode mode-grid"
          title="Grid"
          data-role="mode-switcher"
          data-value="grid"
          id="mode-grid"
          aria-labelledby="modes-label mode-grid"
          onClick={() => changeView(viewMode.GRID)}
        >
          <span>Grid</span>
        </a>
        <strong
          title="List"
          className="modes-mode active mode-list"
          data-value="list"
        >
          <span>List</span>
        </strong>
      </div>
    );
  };

  return (
    <React.Fragment>
      {resultMode === viewMode.GRID
        ? renderGridMode()
        : renderListMode()}
    </React.Fragment>
  );
};